import { promoData } from "./promoConfig";

export function getDisplayedPrice(tier, userInfo) {
  // Calculer le prix par contenu basé sur le nombre d'analyses par mois
  const analysesPerMonth = getAnalysesPerMonth(tier.title);
  const pricePerContent = (parseFloat(tier.price) / analysesPerMonth).toFixed(
    2
  );

  // Vérifier si le plan est en promo et récupérer le pourcentage
  const discountPercent = promoData.plansOnPromo[tier.title];

  if (!userInfo?.coupon_details || !discountPercent) {
    return {
      isPromo: false,
      price: tier.price,
      pricePerContent: pricePerContent,
    };
  }

  const oldPrice = tier.price;
  const discountedPrice = Math.round(oldPrice * (1 - discountPercent / 100));

  const oldPricePerContent = (parseFloat(oldPrice) / analysesPerMonth).toFixed(
    2
  );
  const discountedPricePerContent = (
    parseFloat(discountedPrice) / analysesPerMonth
  ).toFixed(2);

  return {
    isPromo: true,
    oldPrice,
    price: discountedPrice,
    percent: discountPercent,
    oldPricePerContent: oldPricePerContent,
    pricePerContent: discountedPricePerContent,
  };
}

// Fonction pour obtenir le nombre d'analyses par mois selon le plan
export function getAnalysesPerMonth(planTitle) {
  switch (planTitle) {
    case "Jetons SEO":
      return 25;
    case "Starter":
      return 10;
    case "Avancé":
      return 30;
    case "Expert":
      return 100;
    default:
      return 10; // Valeur par défaut
  }
}
